<template>
  <div class="page1">
    <div style="height: 10px"></div>

    <div class="system_div">
      <div class="wallet">
        <div class="wallet_money">
          <img class="tongzhi_icon" src="@/assets/image/user/tongzhi.png" alt="" />

          <div>
            <span class="xxtsy">消息提示音：{{ notify_mp3_item.name }}</span>

            <span class="cutmp3" @click="cut_notify()">
              <Tooltip content="切换提示音" placement="top-start">
                <Icon
                  style="margin-left: 3px"
                  size="18"
                  color="#0466dd"
                  type="md-repeat"
                />
              </Tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="system_div">
      <div class="wallet">
        <div class="wallet_money">
          <img class="tongzhi_icon" src="@/assets/image/user/tongzhi.png" alt="" />

          <div>
            <span class="xxtsy">浏览器通知频率/秒：</span>

            <span class="cutmp3">
              <InputNumber
                size="small"
                v-model="browser_notify_frequency"
                @on-change="browser_notify_frequency_change"
              />
              秒
            </span>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="cut_notify_show" title="切换提示音" :footer-hide="true" width="320">
      <!-- {{ shiting_mp3_item }} -->

      <div>
        <Select
          v-model="shiting_mp3_item.mp3_id"
          style="width: 150px"
          @on-change="notify_mp3_change"
        >
          <Option
            v-for="item in notify_mp3_item.mp3_list"
            :value="item.mp3_id"
            :key="item.mp3_id"
            >{{ item.name }}</Option
          >
        </Select>

        <Button @click="click_shiting" style="margin-left: 10px"
          ><Icon type="ios-headset" /> 试听</Button
        >
      </div>

      <audio v-if="shiting_show" id="notify_mp3_shiting" controls style="display: none">
        <source :src="shiting_mp3_item.url" type="audio/mpeg" />
      </audio>

      <div class="ModalButton">
        <Button type="primary" @click="update_notify_mp3">确认保存</Button>
      </div>
    </Modal>

    <!-- 播放音频 -->

    <audio id="notify_mp3_url" controls v-if="notify_mp3_show">
      <source :src="notify_mp3_url" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import { http, open_new_page, get_browser_id } from "@/utils/http.js";

export default {
  name: "system_setting",
  data() {
    return {
      //
      notify_mp3_item: {
        name: "",
        mp3_id: "",
        mp3_list: [],
      },
      shiting_show: true,
      shiting_mp3_item: {
        mp3_id: "",
        url: "",
      },
      cut_notify_show: false,
      browser_notify_frequency: 5,
    };
  },

  mounted() {},
  methods: {
    browser_notify_frequency_change(e) {
      console.log(e);
      var that = this;
      var obj = {
        second: this.browser_notify_frequency,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/v2/browser_notify_frequency_update",

        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取通知频率
    browser_notify_frequency_get() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/v2/get_browser_notify_frequency",

        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.browser_notify_frequency = res.data.browser_notify_frequency;
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 切换提示音
    cut_notify() {
      this.cut_notify_show = true;
      this.shiting_mp3_item.mp3_id = this.notify_mp3_item.mp3_id;
      this.shiting_mp3_item.url = this.notify_mp3_item.url;
      this.shiting_show = false;
      var that = this;
      setTimeout(function () {
        that.shiting_show = true;
      }, 100);
    },

    open() {
      this.get_notify_mp3();
      this.browser_notify_frequency_get();
    },
    // 获取通知铃声
    get_notify_mp3() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/notify_mp3_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            this.notify_mp3_item = res.data;
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 试听
    click_shiting() {
      this.shiting_show = false;
      this.shiting_show = true;
      console.log(this.shiting_mp3_item);
      var audioElement = document.getElementById("notify_mp3_shiting");
      audioElement.play().catch((error) => {
        console.log(error);
      });
    },

    notify_mp3_change(e) {
      console.log(e);
      var that = this;
      if (e) {
        for (var i = 0; i < this.notify_mp3_item.mp3_list.length; i++) {
          var item = this.notify_mp3_item.mp3_list[i];
          console.log(item);
          if (item.mp3_id == e) {
            this.shiting_mp3_item.mp3_id = item.mp3_id;
            this.shiting_mp3_item.url = item.url;
            console.log(this.shiting_mp3_item);
            this.shiting_show = false;
            setTimeout(function () {
              that.shiting_show = true;
            }, 100);

            break;
          }
        }
      }
    },

    update_notify_mp3() {
      var that = this;
      var obj = {
        mp3_id: this.shiting_mp3_item.mp3_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/update_notify_mp3",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.$emit("change", "update_notify_mp3");
            that.cut_notify_show = false;
            that.get_notify_mp3();
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.xxtsy {
  color: #888;
}

#notify_mp3_url {
  display: none;
}

.ModalButton {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.cutmp3 {
  cursor: pointer;
}

.wallet_money_count {
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}

.wallet_money_txt {
  font-size: 16px;
  padding-top: 10px;
  color: #383838;
}

.wallet_money {
  display: flex;
  align-items: center;
}

.wallet_icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.tongzhi_icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.wallet {
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 10px;
  background: #fff;
}

.system_div {
  background: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 10px;
}

.page1 {
  width: calc(100vw - 120px);
  min-height: 100vh;
  background: #ececec;
}
</style>
